import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';

import { CommonSettingsState } from './state';

@NgModule({
  imports: [
    CommonModule,
    NgxsModule.forFeature([CommonSettingsState]),
  ],
})
export class CommonSettingsModule {}
